<template>
  <v-container>
    <v-row>
      <v-col cols="12" md="8" offset-md="2">
        <v-card class="my-5">
          <v-card-title>
            <v-btn text small @click="$router.back()">
              <v-icon left>mdi-arrow-left</v-icon>
              Back
            </v-btn>
            <v-spacer />
            <!-- Commented out as iframe has built-in download functionality -->
            <!-- <v-btn
              small
              class="mr-2"
              color="secondary"
              @click="downloadFile(invoice, `INVOICE-${currentDate()}.pdf`)"
            >
              <v-icon left>mdi-download</v-icon>
              Download
            </v-btn> -->

            <v-btn
              v-if="service && !service.postedReceiptNo"
              @click="pay(service)"
              small
              color="secondary"
            >
              Pay Now
              <v-icon right>mdi-arrow-right</v-icon>
            </v-btn>
          </v-card-title>
          <v-sheet color="`grey" class="pa-3" v-if="invoice === undefined">
            <v-skeleton-loader
              class="mx-auto"
              max-width="300"
              type="card"
            ></v-skeleton-loader>
          </v-sheet>
          <v-sheet
            color="`grey"
            class="pa-3"
            v-if="
              (invoice !== undefined && invoice.includes('Invalid')) ||
              invoice === ''
            "
          >
            <v-skeleton-loader
              class="mx-auto"
              max-width="300"
              type="card"
            ></v-skeleton-loader>
            <span>Invalid receipt No.</span>
          </v-sheet>

          <!-- PDF Viewer Iframe (Desktop) / Mobile Placeholder -->
          <v-card-text
            v-else-if="invoice"
            class="pa-0"
            style="height: 80vh; min-height: 700px; position: relative; background: #525659"
            :style="{
              height: isMobile ? 'auto' : '80vh',
              minHeight: isMobile ? '300px' : '700px',
              position: 'relative',
              background: isMobile ? '#ffffff' : '#525659'
            }"
          >
            <!-- Loader while Blob URL is being created/loaded -->
            <div v-if="!pdfUrl" class="pa-4 white" style="height: 100%">
              <v-skeleton-loader type="image" height="100%" />
            </div>

            <template v-else>
              <!-- Mobile Optimized View -->
              <div v-if="isMobile" class="pa-12 text-center d-flex flex-column align-center justify-center">
                <v-icon size="100" color="primary lighten-4">mdi-file-pdf-box</v-icon>
                <div class="mt-6 grey--text text--darken-2 headline font-weight-bold">
                  Invoice Preview
                </div>
                <div class="mt-2 grey--text subtitle-1 mb-8">
                  Your invoice is ready. Since you are on a mobile device, please use the button below to view it.
                </div>
                <v-btn
                  x-large
                  color="primary"
                  class="text-none px-8 rounded-lg shadow-lg"
                  @click="openPdfInNewTab"
                >
                  <v-icon left>mdi-eye</v-icon>
                  Open Invoice
                </v-btn>
                <div class="mt-4 grey--text caption">
                  The document will open in your device's native PDF viewer.
                </div>
              </div>

              <!-- Desktop Iframe View -->
              <iframe
                v-else
                :src="pdfUrl"
                width="100%"
                height="100%"
                frameborder="0"
                style="border: none; display: block"
                title="Invoice Viewer"
                loading="lazy"
              ></iframe>
            </template>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <checkout />
  </v-container>
</template>

<script>
import { appUrl } from "../../../environment/environment";
import FileMixin from "../../../mixins/FileMixin";
import DateMixin from "../../../mixins/DateMixin";
import RouterMixin from "../../../router/RouterMixin";
import PdfViewerMixin from "../../../mixins/PdfViewerMixin";
import Checkout from "@kinetics254/paygate/src/views/Checkout.vue";

export default {
  name: "invoice",
  mixins: [FileMixin, DateMixin, RouterMixin, PdfViewerMixin],
  components: { Checkout },
  beforeRouteEnter(to, from, next) {
    next((v) => {
      v.$store.dispatch("Billing/getInvoice", to.params.code);
      // if (from.name !== "upgradeList") {
      //   if (!v.service) v.$router.back();
      // }
    });
  },

  watch: {
    invoice: {
      handler(val) {
        if (val && !val.includes("Invalid")) {
          this.generatePdfUrl(val);
        }
      },
      immediate: true,
    },
  },

  computed: {
    invoice() {
      return this.$store.getters["Billing/invoice"];
    },
    isInvoice() {
      return this.invoice || this.invoice !== "";
    },

    service() {
      return [
        ...this.$store.getters["Application/applications"].filter((s) => {
          return s.Code === this.$route.params.code;
        }),
        ...this.$store.getters["Subscriptions/subscriptions"].filter((s) => {
          return s.memberNo === this.$route.params.code;
        }),
      ].shift();
    },
  },

  methods: {
    pay: function (data) {
      let payload = {
        payerID: data.ProfileID,
        sourceDocumentNo: data.Code,
        description: "Application Payment",
        amount: data.Amount,
        accountNo: "",
        success_url: `${appUrl}${
          this.$router.resolve({ name: "dashboard" }).href
        }`,
        fail_url: window.location.href,
      };

      payload = btoa(JSON.stringify(payload));
      // window.location.href = `${payGateUrl}/?payload=${payload}`;
      this.$checkout.pay(payload);
    },
  },
};
</script>

<style scoped>
iframe {
  border: none;
}

::-webkit-scrollbar {
  width: 8px;
}

::-webkit-scrollbar-track {
  background: #f1f1f1;
}

::-webkit-scrollbar-thumb {
  background: #888;
  border-radius: 4px;
}

::-webkit-scrollbar-thumb:hover {
  background: #555;
}

.shadow-lg {
  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1),
    0 4px 6px -2px rgba(0, 0, 0, 0.05) !important;
}
</style>
